import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {
    // Defensive: string authority'yi array'e çevir
    const normalizedUserAuth = useMemo(
        () => Array.isArray(userAuthority) ? userAuthority : (userAuthority ? [userAuthority] : []),
        [userAuthority]
    )
    const normalizedAuth = useMemo(
        () => Array.isArray(authority) ? authority : (authority ? [authority] : []),
        [authority]
    )

    const roleMatched = useMemo(() => {
        return normalizedAuth.some((role) => normalizedUserAuth.includes(role))
    }, [normalizedAuth, normalizedUserAuth])

    if (
        isEmpty(normalizedAuth) ||
        isEmpty(normalizedUserAuth) ||
        typeof authority === 'undefined'
    ) {
        return !emptyCheck
    }

    return roleMatched
}

export default useAuthority
